var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fee471;}.cls-2{fill:#784ace;}.cls-3{fill:#00dbd5;}.cls-4{fill:#00d89a;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tasks"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M481.59,101.19V577c0,.22,0,.44,0,.66a22.73,22.73,0,0,1-22.73,22.09H71.13A22.75,22.75,0,0,1,48.38,577V101.19A22.75,22.75,0,0,1,71.13,78.44H458.84A22.74,22.74,0,0,1,481.59,101.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.5,
    y: 322.09,
    width: 296.03,
    height: 61.81,
    rx: 30.91,
    transform: "translate(2.66 -1.98) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.55,
    y: 445.71,
    width: 296.03,
    height: 61.81,
    rx: 30.91,
    transform: "translate(3.59 -1.97) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 117.44,
    y: 198.46,
    width: 295.17,
    height: 61.81,
    rx: 30.91,
    transform: "translate(1.73 -1.98) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 168.98,
    y: 49.95,
    width: 192.02,
    height: 62.01,
    rx: 31.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.79,30.73A20.22,20.22,0,1,1,246.57,51a20.24,20.24,0,0,1,20.22-20.22m0-30A50.22,50.22,0,1,0,317,51,50.21,50.21,0,0,0,266.79.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M559.52,448.77a121,121,0,0,1-77.93,113V577c0,.22,0,.44,0,.66A135.79,135.79,0,0,1,303,448.77c0-.93,0-1.85,0-2.77a134.94,134.94,0,0,1,16.27-61.69,136.65,136.65,0,0,1,67.38-60.93,135.94,135.94,0,0,1,94.92-3.46v15.87a121,121,0,0,1,77.93,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M438.76,298a150,150,0,0,0-82.83,24.78h0A150.59,150.59,0,0,0,288,445.89q0,1.44,0,2.88A150.9,150.9,0,0,0,471.25,596a22.67,22.67,0,0,0,10.32-18.41c0-.22,0-.44,0-.66V561.74a120.71,120.71,0,0,1-163.6-113c0-.88,0-1.77,0-2.65a119.66,119.66,0,0,1,18.47-61.68,121.61,121.61,0,0,1,16.86-21.07,121,121,0,0,1,128.23-27.58V304.17A151,151,0,0,0,438.76,298Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M427,513.13a20,20,0,0,1-13.14-4.92l-45.23-39.45a20,20,0,0,1,26.29-30.15l29.66,25.87L478,399a20,20,0,1,1,31,25.29l-66.52,81.48a19.93,19.93,0,0,1-13.8,7.28C428.13,513.11,427.56,513.13,427,513.13Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.54667c4b6c21b18ad25fac1880716a24.svg";
export { ForwardRef as ReactComponent };